// Rightmove Property_Type — full label list from the RTDF schema
// (SendPropertyDetailsRequestSchema.json). Grouped by category for
// discoverability in the CMS dropdown; the value stored in the CMS is
// the exact schema label (case-preserved) so `_RM_PROPERTY_TYPE_MAP` on
// the backend can look it up directly for the outgoing integer code.
export const RIGHTMOVE_PROPERTY_TYPES = [
  {
    label: "Residential — Houses",
    values: [
      "Terraced House",
      "End of terrace house",
      "Semi-detached house",
      "Detached house",
      "Mews house",
      "Cluster house",
      "Link detached house",
      "Town house",
      "Cottage",
      "Chalet",
      "Character Property",
      "House (unspecified)",
      "Villa",
      "Barn Conversion",
      "Farm House",
      "Duplex",
      "Triplex",
      "Longere",
      "Gite",
      "Barn",
      "Trulli",
      "Mill",
      "Ruins",
      "Village House",
      "Cave House",
      "Cortijo",
      "Country House",
      "Stone House",
      "Semi-detached Villa",
      "Detached Villa",
      "Riad",
      "Manor House",
      "Stately Home",
      "Coach House",
      "House of Multiple Occupation",
    ],
  },
  {
    label: "Residential — Flats / Apartments",
    values: [
      "Ground floor flat",
      "Flat",
      "Studio flat",
      "Ground floor maisonette",
      "Maisonette",
      "Apartment",
      "Penthouse",
      "Serviced apartment",
      "Block of Apartments",
      "Private Halls",
      "Sheltered Housing",
      "Retirement property",
      "House share",
      "Flat share",
    ],
  },
  {
    label: "Residential — Bungalows & Mobile",
    values: [
      "Bungalow",
      "Terraced bungalow",
      "Semi-detached bungalow",
      "Detached bungalow",
      "Mobile home",
      "Park home",
      "Caravan",
      "Lodge",
      "Log Cabin",
      "House Boat",
    ],
  },
  {
    label: "Residential — Other",
    values: [
      "Finca",
      "Off-Plan",
      "Not Specified",
    ],
  },
  {
    label: "Land & Plots",
    values: [
      "Land (Residential)",
      "Farm Land",
      "Plot",
      "Land (Commercial)",
    ],
  },
  {
    label: "Parking & Garages",
    values: [
      "Parking",
      "Garages",
      "Garages (Commercial)",
    ],
  },
  {
    label: "Commercial — Retail & Hospitality",
    values: [
      "Restaurant",
      "Cafe",
      "Shop",
      "Bar/Nightclub",
      "Convenience Store",
      "Hairdresser/Barber Shop",
      "Hotel",
      "Hotel Room",
      "Petrol Station",
      "Post Office",
      "Pub",
      "Takeaway",
      "Guest House",
      "Hospitality",
      "Trade Counter",
      "Retail Property (High Street)",
      "Retail Property (Out of Town)",
      "Retail Property (Shopping Centre)",
      "Retail Property (Park)",
      "Retail Property (Pop Up)",
    ],
  },
  {
    label: "Commercial — Office & Industrial",
    values: [
      "Office",
      "Business Park",
      "Serviced Office",
      "Distribution Warehouse",
      "Factory",
      "Heavy Industrial",
      "Industrial Park",
      "Light Industrial",
      "Storage",
      "Showroom",
      "Warehouse",
      "Workshop & Retail Space",
      "Mill (Business)",
    ],
  },
  {
    label: "Commercial — Specialist",
    values: [
      "Commercial Development",
      "Industrial Development",
      "Residential Development",
      "Commercial Property",
      "Data Centre",
      "Farm",
      "Equestrian facility",
      "Healthcare Facility",
      "Marine Property",
      "Mixed Use",
      "Research & Development Facility",
      "Science Park",
      "Leisure Facility",
      "Childcare Facility",
      "Smallholding",
      "Place of Worship",
      "Sports facilities",
      "Spa",
      "Campsite & Holiday Village",
      "Castle",
    ],
  },
];

// Legacy CMS lowercase values → schema labels (used to backfill existing
// property records when the modal opens, so the new dropdown shows the
// correct selected option).
export const LEGACY_PROPERTY_TYPE_MAP = {
  terraced: "Terraced House",
  "semi-detached": "Semi-detached house",
  detached: "Detached house",
  townhouse: "Town house",
  flat: "Flat",
  bungalow: "Bungalow",
  land: "Land (Residential)",
};

// Flat list of every allowed value — useful for validators.
export const RIGHTMOVE_PROPERTY_TYPE_VALUES = RIGHTMOVE_PROPERTY_TYPES.flatMap(
  (g) => g.values
);
